import { Box, List, ListItem, Text, Link } from '@chakra-ui/react';

import React from 'react';

const Contents: React.FC = () => (
  <Box marginX="15px" marginY="10px">
    <Text>
      就職活動を進めるにあたって、リケイマッチでは就活に役立つコンテンツを作成しています！
      <br />
      気になるものがあれば、ぜひご参照ください。
    </Text>
    <br />
    <List>
      <ListItem>
        <Text fontWeight="semibold">１、理系学部生向けのガクチカ集</Text>
        <Text>
          理系学部生向けのガクチカ集を２６パターンご用意しました！
          <br />
          文系や理系院生向けの内容はネット上に溢れているのですが、学部生向けだとなぜか中々見つからないので、リケイマッチ独自で作ってみました。
        </Text>
        <br />
        <Text>資料はこちらから</Text>
        <Link
          color="#0000ee"
          href="https://drive.google.com/file/d/1rW8lFdBGjTdw3Do6Q8XyZ5vPWAUlSZcP/view"
        >
          https://drive.google.com/file/d/1rW8lFdBGjTdw3Do6Q8XyZ5vPWAUlSZcP/view
        </Link>
      </ListItem>
      <br />
      <ListItem>
        <Text fontWeight="semibold">２、理系学部生向けの面接質問集</Text>
        <Text>
          「文理問わない質問集」「理系ならではの質問集」「ITエンジニアならではの質問集」の３点で取りまとめています。
        </Text>
        <Text>
          今回の作成にあたって内定者だけでなく、企業人事の方々（電機メーカー、自動車部品メーカー、IT/Web企業）にもご協力いただきました。
        </Text>
        <br />
        <Text>資料はこちらから</Text>
        <Link
          color="#0000ee"
          href="https://drive.google.com/file/d/1kfC9oXbbN7lYSY05D-62YFOfqiY4NJkp/view"
        >
          https://drive.google.com/file/d/1kfC9oXbbN7lYSY05D-62YFOfqiY4NJkp/view
        </Link>
      </ListItem>
      <br />
      <ListItem>
        <Text fontWeight="semibold">３、23卒向け 就活スケジュール</Text>
        <Text>
          2023年卒の学生さん向けに、就活スケジュールについてまとめました。
        </Text>
        <Text>
          一般的な流れだけでなく、「時期ごとに意識したほうがいいこと」「例外的な動きをする企業もあること」など補足説明しています。
        </Text>
        <br />
        <Text>資料はこちらから</Text>
        <Link
          color="#0000ee"
          href="https://drive.google.com/file/d/1mauvHURGR0Nokrlfcr-Z5fBFu12dqeXA/view"
        >
          https://drive.google.com/file/d/1mauvHURGR0Nokrlfcr-Z5fBFu12dqeXA/view
        </Link>
      </ListItem>
      <br />
      <ListItem>
        <Text fontWeight="semibold">４、企業研究の方法（IT、製造業）</Text>
        <Text>企業研究をどのような流れで進めていくのかまとめました。</Text>
        <Text>
          業界研究や個社ごとの調査について具体的な手法も記載しています。IT系や製造業ならではの内容も盛り込みました。
        </Text>
        <br />
        <Text>資料はこちらから</Text>
        <Link
          color="#0000ee"
          href="https://drive.google.com/file/d/1mEKORZ4xtBOMFwJSgL06AJT1GB81dekd/view"
        >
          https://drive.google.com/file/d/1mEKORZ4xtBOMFwJSgL06AJT1GB81dekd/view
        </Link>
      </ListItem>
      <br />
      <ListItem>
        <Text>
          コンテンツに関する質問や作成要望があれば、下記のメールアドレス宛へお気軽にご連絡ください
        </Text>
        <Link color="#0000ee" href="mailto:contact@cambiainc.co.jp">
          contact@cambiainc.co.jp
        </Link>
      </ListItem>
    </List>
    <br />
    <Text>※コンテンツは追加次第、メールでも告知させていただきます※</Text>
  </Box>
);

export default Contents;
